import { render, staticRenderFns } from "./ActiveCombat.vue?vue&type=template&id=5b774eb0&"
import script from "./ActiveCombat.vue?vue&type=script&lang=ts&"
export * from "./ActiveCombat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports